import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue';
import Settings from './../../resources/setts.js'; //Settings

let service = new services();
export default {
    name: 'Home',
    mixins: [Settings],
    data () {
        return {
            header_data:{},
            user:{},
            transfer:{},
            transfers:{},
            transfer_item:{},
            transfer_ref:'',
            loggedIn: false,
            loading: true,
            tab_view: {},
            menu_tab_view:{},
            set_view:false,
            img_product_url: service.imageProductsURL,

            //
            is_agent: false,
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        },

    },
    methods: {
        setComponent(attr1,attr2){
            if(attr1 == "reset-edit"){}
        },

        setTabComponent(view){
            this.tab_view = {};
            this.tab_view[view] =  true;
        },

        setMenuTabView(view,attr1,attr2){
            if(this.menu_tab_view[view] == true){//toggle reverse
                this.menu_tab_view = {};
                //this.setComponent('reset-edit','');
            }else{
                //this.setComponent('reset-edit','');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
            //
            if(view == "viewTransfer"){
                this.transfer = attr1;
            }
        },

        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.getTransferOrders();
                    self.loading = false;
                }else {
                    self.$router.push('login');
                    // console.log(err)
                }
            });
        },

        addProductsToTransferOrder(){

        },

        makeTransFerOrder(){
            let order_items = [];
            //
            let item = {
                order_item_id: 9,
                order_item_order_quantity:2,
            }
            let item2 = {
                order_item_id: 10,
                order_item_order_quantity:3,
            }
            order_items.push(item);
            order_items.push(item2);
            //
            var payload = {
                order_user:this.user.user_id,
                order_payment_order:14,
                order_items:order_items,
            }
            service.acceptPaymentOrder(this, payload).then(response => {
                if(response.body.status == 201) {
                    console.log(response.body)
                }
            }).catch((err) => {})
        },

        setGenerateReceipt(){
            let order_items = [];
            //
            let item = {
                order_item_module: 8,//order
                order_item_module_id: 718,
                order_item_amount:2800,
                order_item_order_quantity:1,
            }
            let item2 = {
                order_item_module: 8,//order
                order_item_module_id: 719,
                order_item_amount:2200,
                order_item_order_quantity:1,
            }
            order_items.push(item);
            order_items.push(item2)
            var payload = {
                order_business:232,
                order_amount:2800,
                order_items:order_items,
            }
            service.generatePaymentOrder(this, payload).then(response => {
                if(response.body.status == 201) {
                    console.log(response.body)
                }
            }).catch((err) => {})
        },
        
        getTransferOrders(){
            var payload = {
                order_user: this.user.user_id,
            }
            service.getPaymentOrders(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.transfers = response.body.data; 
                }
            }).catch((err) => {})
        },

        getTransferDetails(){
            var payload = {
                ref: this.transfer_ref,
            }
            service.getPaymentOrderDetails(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.transfer = response.body.data; 
                    this.setMenuTabView('viewTransfer');
                }
            }).catch((err) => {})
        },
        
    },
    created: function(){
        this.preset();
        this.header_data.name = "Agent Services";
        this.is_agent = false;
    }
}


// WEBPACK FOOTER //
// ./src/pages/AgentServices/script.js